import gql from "graphql-tag";
import { RIGHT_FRAGMENT, ROLE_FRAGMENT } from "../role/fragment";

export const USER_FRAGMENT = gql`
  fragment UserInfo on User {
    accountUsed
    email
    firstname
    gender
    id
    isActive
    isInvitationAccepted
    isLegalRepresentative
    mobilePhoneNumber
    name
    rights {
      ...RightInfo
    }
    role {
      ...RoleInfo
    }
    team
    type
  }
  ${ROLE_FRAGMENT}
  ${RIGHT_FRAGMENT}
`;

export const USER_INVITED_FRAGMENT = gql`
  fragment UserInvitedInfo on UserInvited {
    address
    city
    cityOfBirth
    companyName
    countryIsoCode
    countryOfBirthIsoCode
    dateOfBirth
    email
    firstname
    gender
    id
    isInvitationAccepted
    isShares
    mobilePhoneNumber
    name
    nationalityCountryIsoCode
    postcode
    role
    specifiedUSPerson
    type
  }
`;
